.nicheCard {
  display: flex;
  flex-wrap: wrap;
  text-decoration: none;
  align-items: center;

  .nicheCardImageWrap {
    flex-shrink: 0;
    display: grid;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-right: 8px;
  }

  .nicheCardInfo {
    display: flex;
    flex-direction: column;
  }

  .nicheName {
    font: var(--font-body-md-medium);
    line-height: 25px;
    color: var(--primitives-colors-neutral-0);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    max-width: 220px;

    .phone &,
    .tablet & {
      max-width: 170px;
    }
  }

  .nicheFollowers {
    text-transform: uppercase;
    font: var(--font-body-sm-regular);
    line-height: 22px;
    color: var(--semantic-colors-typography-faded);
    display: block;
    margin-top: 2px;
  }
}